/* eslint-disable @typescript-eslint/naming-convention */
import { Components, Theme } from '@mui/material/styles';

export const MuiIconButton: Components<Omit<Theme, 'components'>>['MuiIconButton'] = {
  styleOverrides: {
    root: {
      margin: 0,
      borderRadius: '0.5rem',
      '&:hover': {
        backgroundColor: 'var(--color-surf-container-highest)',
      },
      color: 'var(--color-on-surf-variant)',
      '&.Mui-disabled': {
        color: 'var(--color-outline)',
      },
    },
  },
};
